import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Container, Row, Col, Button } from "reactstrap";

const rowClass = {
  marginTop: '60px',
};
const notAvailText = {
  fontWeight: 200,
  color: 'darkgray'
};
const notAvailImage = {
  maxWidth: '50%',
  height:'auto'
};
const notAvailButton = {
  backgroundColor: 'white',
  borderColor: '#3f51b5',
  color:'#3f51b5',
  marginTop: '15px'
};

const Error500 = props => {
  return (
    <>
      <div className="main-content">
        <div className="header py-7 py-lg-8 ">
          <Container>
            <div className="header-body text-center mb-7">
              <Row className="justify-content-center" style={rowClass}>
                <Col class="col-xs-5 col-sm-6 col-lg-4">
                  <h1>Oops, something went terribly wrong!</h1>
                  <p className="text-lead" style={notAvailText}>
                    This page is currently not available. We are working on the problem, and appreciate your patience.
                  </p>
                  <img
                    alt="Under development"
                    src={require("assets/img/brand/undraw_server_down_s4lk.svg")}
                    style={notAvailImage}
                  />
                  <div>
                    <Button
                      color="primary"
                      tag={RouterLink}
                      exact
                      to="/auth/login"
                      variant="outlined"
                      style={notAvailButton}
                    >
                      BACK TO HOME
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Error500;
